// Admin-editable overrides for the built-in per-language dictionaries kept in React sources.
// `dict` is { fr: {...}, en: {...}, ... } (leaves = strings, nested objects/arrays allowed);
// every leaf is replaced by translations["<prefix>.<path>"] when the admin defined one
// (Admin › Traductions), then {vars} placeholders are filled. Same paths as
// scripts/extract_local_texts.js, which seeds those keys server-side.
const fill = (text, vars) => {
  if (!vars) return text;
  return Object.keys(vars).reduce((acc, k) => acc.split(`{${k}}`).join(vars[k] == null ? "" : String(vars[k])), text);
};

const walk = (value, path, translations, vars) => {
  if (typeof value === "string") {
    const override = translations?.[path];
    return fill(typeof override === "string" && override ? override : value, vars);
  }
  if (Array.isArray(value)) return value.map((v, i) => walk(v, `${path}.${i}`, translations, vars));
  if (value && typeof value === "object") {
    const out = {};
    Object.keys(value).forEach((k) => { out[k] = walk(value[k], `${path}.${k}`, translations, vars); });
    return out;
  }
  return value;
};

export const localizeDict = (dict, lang, translations, prefix, vars) => {
  const base = dict[lang] || dict.fr;
  // Keys missing in a language fall back to French so nothing renders as `undefined`.
  const merged = Array.isArray(base) ? base : { ...dict.fr, ...base };
  return walk(merged, prefix, translations, vars);
};
